<template>
  <section class="todo-list-container">
    <base-header
      v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="listParams"
      @handleSearch="handleSearchs"
    ></search-header>
    <nwwd-table
      @handleBatchAll="handleBatchAll"
      @handleDelete='handleDelete'
      @handleEdit='handleEdit'
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      v-bind="list"
      :header='header'
      :footButtons="footButtons"
    >
    </nwwd-table>
    <form-dialog
      title="新建回复"
      ref="newClassifyDialog"
      :loading="newClassifyLoading"
      :form="newClassifyFrom"
      :rules="newClassifyRules"
      :formItems="newClassifyFormItems"
      :buttons="newClassifyButtons"
      v-on:handleConfirm="handleNewClassify"
      class="ans-dialog"
    ></form-dialog>
    <form-dialog
      title="编辑回复"
      ref="compileDialog"
      :loading="compileLoading"
      :form="compileForm"
      :rules="compileRules"
      :formItems="compileItems"
      :buttons="compileButtons"
      v-on:handleConfirm="handlecompile"
      class="ans-dialog"
    ></form-dialog>
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import nwwdTable from '@/components/mixins/nwwdTable'
import formDialog from '@/components/mixins/formDialog'
import ansMixin from './ansMixin.js'
import {
  mapActions
} from 'vuex'
export default {
  name: 'AnsList',
  mixins: [nwwdTable, searchHeader, baseHeader, formDialog, ansMixin],
  data () {
    return {
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '官方回复',
            icon: 'jia',
            disabled: !this._checkPermission('/linkTypes', 'POST')
          },
        ],
        title: '',
        showAlertIcon: false
        // content: '操作说明'
      },
      newClassifyLoading: false,
      newClassifyFrom: {},
      newClassifyRules: {
        content: [this.$rules.required(), this.$rules.cnEnNum()]
      },
      newClassifyFormItems: [
        {
          prop: 'content',
          maxlength: 150,
          type: 'textarea',
          autosize: { minRows: 3 },
          placeholder: '请输入内容'
        }
      ],
      newClassifyButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ],
      compileLoading: false,
      compileForm: {},
      compileRules: { content: [this.$rules.required(), this.$rules.cnEnNum()] },
      compileItems: [
        {
          prop: 'content',
          maxlength: 150,
          type: 'textarea',
          autosize: { minRows: 3 },
          placeholder: '请输入内容'
        }
      ],
      compileButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ]
    }
  },
  methods: {
    ...mapActions('config', ['FetchSitesOwnsite']),
    // handleOpencomment (data, index) {
    //   this.$routerLink('/interact/comment/Content?contentId=' + data.content.id)
    // },
    handleOpenNews (data, index) {
      if (data.content && data.content.urlWhole) {
        window.open(data.content.urlWhole)
      } else {
        this.$message('没有浏览地址')
      }
    },
    // 打开新建回复
    handleHeaderCreate () {
      this.$refs.newClassifyDialog.showDialog()
    },
    //打开编辑回复
    handleEdit (data) {
      // console.log(data);
      var tempData = {
        id:data.id,
        content:data.content
      }

      this.compileForm = tempData
      this.$refs.compileDialog.showDialog()
    },
    // 新建确认
    handleNewClassify (data) {
      data.questionId = this.list.params.questionId
      data.author = this.user.userName
      // console.log('新建',data);
      this.newClassifyLoading = true
      this.$request.fetchAnswerAdd(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新建成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
        this.newClassifyLoading = false
      }).catch(() => { this.newClassifyLoading = false })
    },
    // 编辑确认
    handlecompile (data) {
      // console.log('编辑',data);
      this.compileLoading = true
      this.$request.fetchAnswerEdit(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
        this.compileLoading = false
      }).catch(() => { this.compileLoading = false })
    },
    // 弹窗信息
    msgChange (message, fn, params) {
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        fn(params)
      }).catch(() => {})
    },
    // 搜索处理
    handleSearchs () {
      var params = this.listParams
      // console.log(params);
     if (params.datetime) {
        this.list.params.timeStart = params.datetime[0]
        this.list.params.timeEnd = params.datetime[1]
      } else {
        this.list.params.timeStart = ''
        this.list.params.timeEnd = ''
      }
      this.list.params.author = params.author
      this.list.params.type = params.type
      this.fetchCommentApi()
    },
    // 回调
    fetchContentCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.data
        this.list.totalCount = res.data.totalCount
      }
    },
    // 批量点击
    handleBatchAll (ids, btn) {
      if (ids.length > 0) {
        switch (btn.btn) {
          case 'Delete':
            // 批量删除
            this.handleDelete(ids, 1)
            break
          default:
            break
        }
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 删除
    handleDelete (data) {
      var ids = []
      // console.log(data);
      if (data instanceof Array) {
        ids = data
      } else {
        ids = [data.id]
      }
      if (ids.length === 0) {
        this.$message('请选择需要删除的内容')
      } else {
        this.msgChange('是否确定删除选中内容？', this.fetchAnswerDelete, ids)
      }
    },
    // 接口访问
    // 删除
    fetchAnswerDelete (ids) {
      console.log(ids);
      this.$request.fetchAnswerDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 查询列表数量
    fetchInteractUsercommentCount (data) {
      this.$request.fetchInteractUsercommentCount(data).then(res => {
        if (res.code === 200) {
          this.reportNum = res.data.reportNum
        }
      })
    },
  },
  computed: {
    user(){
      return this.$store.getters.user
    }
  },
  mounted () {
    const { questionId } = this.$route.query
    this.list.params.questionId = questionId
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      if (newRoute.name === 'interactAnsList') {
        const { questionId } = newRoute.query
        if (questionId && questionId !== this.list.params.questionId) {
          this.list.params.questionId = questionId
          this.fetchCommentApi()
        }
      }
    }
  }
}
</script>
<style lang='scss'>
.el-popover{
  .ct-pover__box{
    .ct-pover__item{
      .el-link--inner{
        .liulan{
          font-size: 14px!important;
        }
      }

    }
  }
}
.todo-list-container{

  .ct-wrap .ct-box__cont {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    color: #666;
    align-items: center;
    justify-content: space-between;
    background-color: #f9f9f9;
  }
  .ct-wrap .ct-box .ct-box__item {
      align-items: center;
      margin-right: 30px;
  }
  .base-header-container{
    header{
      padding-bottom: 10px!important;
    }
    .list-wrap-btn.el-button.el-button--medium.is-plain{
      border-color: #e8e8e8;
      color: #333333;
      font-size: 14px;
      .jee-svg-icon{
        width: 10px;
        fill: #333333;
      }
    }
  }
}
.todo-list-order-type{
  .el-select-dropdown__wrap{
    max-height: 353px;
  }
}
.todo-list-status{
  .el-select-dropdown__wrap{
    max-height: 290px;
  }
}
.ans-dialog .el-form-item__content {
  margin-left:0 !important
}
.ans-dialog .el-textarea {
  max-width: none !important;
}
</style>
